import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";

export const getPhotos = createAsyncThunk('gallery/getPhotos',
  async () => {
    const url = `v1/mobile/image_galleries`
    
    const response: AxiosResponse<PhotosPagination> = await instance.get(url)
    return response.data
  })

export const addPhoto = createAsyncThunk('gallery/addPhoto',
  async (data: PhotoPayload) => {
    const config = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		}
    const formData = new FormData();
    formData.append('title', data.title);
    formData.append('description', data.description);
    formData.append('is_show', String(data.is_show));
    formData.append('file', data.file);
    const response: AxiosResponse<Photo> = await instance.post('v1/mobile/image_galleries', formData, config)
    return response.data
  })

export const deletePhoto = createAsyncThunk('gallery/deletePhoto',
  async (id: string) => {
    const response: AxiosResponse<Photo> = await instance.delete(`v1/mobile/image_galleries/${id}`)
    return response.data
  })


